<template>
  <div class="col-xs-12 col-sm-10 default-list-contain-sty">
    <div>
      <div class="order-main-title-sty">
        <h5>
          <span>
            服務日期 <b>{{orderInfo.roc_date}}</b>
          </span>
          <span style="margin-left:25px;">
            服務金額 <b>{{orderInfo.raw_cash}}</b>
          </span>
        </h5>
      </div>
      <hr>
      <div class="order-contain">
        <div>
            <p>
              匯款完成後<br/>
              請將匯款帳戶後5碼於下方輸入 <br/>
              我們將會有專人為您確認
            </p>
          </div>
        <b-form-group
          label="請輸入匯款帳戶後5碼"
          label-for="edit-address"
          style="font-weight: bolder;"
        >
          <input type="number" class="form-control re-order-input-sty" id="transfer_code" name="transfer_code" v-model="transfer_code" placeholder="您的帳戶後五碼">
        </b-form-group>
        <b-form-group label="匯款日期">
          <b-form-datepicker id="transfer_date" v-model="transfer_date" class="mb-2 re-order-input-sty"></b-form-datepicker>
        </b-form-group>
      </div>
      <div class="order-footer-contain text-right">
        <b-button
            class="text-white order-info-btn-sty"
            variant="info"
            size="md"
            @click="checkOrderTransfer">
            送出
        </b-button>
      </div>
    </div>
    <b-modal id="rsOrderTransfer" ref="rsordertransfer-modal">
      <template>
        <div class="row">
          <span>成功送出!</span>
          <span>期待下次與您的相遇</span>
        </div>
      </template>
      <template #modal-footer>
        <b-button size="lg" variant="info" @click="closeLiff()" style="width:100px;">
          確認
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'OrderTransferCode',
  props: {
    userId: String,
    userType: String,
    orderId: String
  },
  data () {
    return {
      orderInfo: {},
      transfer_code: null,
      transfer_date: null,
      isLoad: false
    }
  },
  created () {
    this.$nextTick(() => {
      this.getOrderInfo()
    })
  },
  watch: {
    transfer_code (value) {
      var valArr = []
      var finalVal
      if (value) {
        valArr = String(value).split('')
        if (valArr.length > 5) {
          valArr.splice(5)
          finalVal = parseInt(valArr.join(''))
          console.log(finalVal)
          this.transfer_code = finalVal
        }
      }
    }
  },
  methods: {
    getOrderInfo () {
      const self = this
      const getUrl = this.$apiDoc.customerUrl + this.userId + this.$apiDoc.apiPostOrder + this.orderId
      var errorMsg = this.$toolDoc.defaultErrorMsg
      this.$parent.isLoadShow = true
      this.$api.get(getUrl, {}).then((resp) => {
        if (resp.result) {
          self.orderInfo = self.arrangeOrderData(resp.data)
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          alert(errorMsg)
          self.$parent.isLoadShow = false
        }
      }).catch((errorInfo) => {
        console.warn('errorInfo', errorInfo)
        alert(errorMsg)
        self.$parent.isLoadShow = false
      })
    },
    arrangeOrderData (data) {
      if (data) {
        data.orderPt = '/' + this.$props.userType + this.$apiDoc.routerOrderInfo + '#' + this.orderId
      }
      this.$parent.isLoadShow = false
      return data
    },
    checkOrderTransfer () {
      var valArr = []
      var isError = true
      var errorMsg = '請完整輸入您帳戶的後五碼，謝謝'
      if (this.transfer_code) {
        valArr = String(this.transfer_code).split('')
        if (valArr.length === 5) {
          if (this.transfer_date) {
            errorMsg = '請選擇匯款日期，謝謝'
            isError = false
          }
        }
      }
      if (isError) {
        this.$bvToast.toast(errorMsg, {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          solid: true
        })
      } else {
        this.submitTransfer()
      }
    },
    submitTransfer () {
      const self = this
      const transferDate = new Date(this.transfer_date).toISOString()
      var finalUrl = this.$apiDoc.customerUrl + this.userId + this.$apiDoc.apiPostOrder + this.orderId + this.$apiDoc.apiPostTransfer
      var options = {
        transfer_code: String(this.transfer_code),
        transfer_at: transferDate
      }
      var errorMsg
      this.$parent.isLoadShow = true
      this.$api.post(finalUrl, options).then((resp) => {
        if (resp.result) {
          self.$bvModal.show('rsOrderTransfer')
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          self.$bvToast.toast(errorMsg, {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
        }
        self.$parent.isLoadShow = false
        this.$liff.closeWindow()
      }).catch((errorInfo) => {
        console.warn('errorInfo', errorInfo)
        self.$parent.isLoadShow = false
        errorMsg = self.$toolDoc.convertErrorMsg(errorInfo)
        self.$bvToast.toast(errorMsg, {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          solid: true
        })
        this.$liff.closeWindow()
      })
    },
    closeLiff () {
      this.$liff.closeWindow()
    }
  }
}
</script>
